import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {Subject} from 'rxjs';
import {GroupSelectComponent} from '../../group/groupselect.component';
import {ThuService} from '../../../../service/email/service-thu';
import {ThuFileService} from '../../../../service/email/service-thufile';
import {DocumentDraftService} from '../../../../service/draft/service-documentdraft';
import {DocumentDraftFileService} from '../../../../service/draft/service-documentdraftfile';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {Thu} from '../../../../models/email/thu';
import {DocumentDraftFile} from '../../../../models/draft/documentdraftfile';
import {SelectStaffComponent} from '../../../ui/selectstaff/selectstaff.component';
import {StaffsService} from '../../../../service/staff/service-staffs';
import {UploadFileMailComponent} from '../../../ui/upload/uploadfilemail.component';
import {ThuFile} from '../../../../models/email/thufile';
import {CommandUtil} from '../../../../global/commandutil';
import {CkEditorUploadAdapter} from '../../../../global/upload-ckeditor';

@Component({
  templateUrl: './guitiep.component.html'

})
export class GuiTiepThuComponent implements OnInit, AfterViewInit {
  @ViewChild(SelectStaffComponent)
  public uiSelectStaff: SelectStaffComponent;
  @ViewChild(UploadFileMailComponent)
  public uploadFileComponent: UploadFileMailComponent;
  public language = language;
  public frmGroup: FormGroup;
  public id: number=0;
  public isEdit: boolean = false;
  public isRefresh: boolean = false;
  public submitValidate = false;
  public checked: boolean = true;
  public editor = ClassicEditor;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[]=[];
  public staffSelectList: Object[]=[];
  public selectedList: Object[]=[];
  public staffSelectReadList: Object[]=[];
  public thuFiles: ThuFile[] = [];
  public dataCheck: Object[]=[];
  public  onClose: Subject<boolean>;
  public contentHtml: String;
  private checkFocus: boolean = false;
  constructor(   public thuService: ThuService,
                 public formBuilder: FormBuilder,
                 public toastr: ToastrService,
                 public bsModalService: BsModalService,
                 public thuFileService: ThuFileService,
                 public _bsModalRef: BsModalRef,
                 public documentDraftService: DocumentDraftService,
                 public documentDraftFileService: DocumentDraftFileService,
                 public staffsService: StaffsService,
                 public commandUtil: CommandUtil
  ) {
  }
  ngAfterViewInit() {

  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  public onReady( editor ) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
    editor.editing.view.change( writer => {
      writer.setStyle( 'height', '300px', editor.editing.view.document.getRoot() );
      writer.setStyle( 'border', '1px solid', editor.editing.view.document.getRoot() );
    } );
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      return new CkEditorUploadAdapter(loader);
    };
  }
  public onFocus(event)
  {
    if(this.checkFocus === false)
    {
      this.contentHtml = '<p></p>' + this.contentHtml;
      this.checkFocus = true;
    }
  }

  public checkAll(event)
  {
    this.dataCheck = [];
    this.checked = event.target.checked;
    if(event.target.checked === true)
    {
      for(let i = 0; i < this.thuFiles.length; i++)
        this.dataCheck.push(this.thuFiles[i].id);
    }
  }
  public checkedItem(event)
  {

    if(event.target.checked === true && this.dataCheck.indexOf(event.target.value) === -1)
      this.dataCheck.push(event.target.value);
    else
      this.dataCheck.splice(this.dataCheck.indexOf(event.target.value),1);
    if(this.dataCheck.length === 0)
      this.checked = false;
  }
  public edit(id: number) {
    this.id = id;
    this.isEdit = (id !== 0) ? true : false;
    this.thuService.getById(id)
      .subscribe(x => {
        this.frmGroup.patchValue(
          {chuDe: x.vanDe,
          noiDung: x.noiDung}
        );
        this.thuFileService.findAllByMulti(this.id + ',' + x.nhomThu + ',' + x.thuGoc).subscribe( y  => {
          this.thuFiles = y;
          for (let i = 0 ; i < this.thuFiles.length; i++)
            this.dataCheck.push(this.thuFiles[i].id);

        });
      });
    /*let files: DocumentDraftFile[];
    this.fileLists =  [];
    this.documentDraftFileService.findAllByDraftId(id).subscribe(
      x => {
        files = x;
        for(let i=0; i< files.length; i++)
        {
          this.fileLists.push({ id: files[i].id,
            title: files[i].name ,
            name: files[i].fileKey,
            size: files[i].size,
            fileType: files[i].width,
            folder: files[i].folder });
        }
        this.uploadFileComponent.uploadCommand["files"]= this.fileLists;
      });*/
  }
  public loadStaffs(sid: string)
  {
    this.staffsService.findAllByStaffId(sid).subscribe(
      x => {
        for ( let i = 0; i < x.length; i++)
        {
          this.staffSelectList= [...this.staffSelectList, {id: x[i].id, fullName: x[i].fullName + (x[i].chucVuItem !== null ? ' (' + x[i].chucVuItem.tenChucVu + ')' : '')}];
          this.selectedList= [...this.selectedList, x[i].id];
        }

      });
  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.frmGroup = new FormGroup({
      id: new FormControl('0'),
      chuDe: new FormControl(),
      noiDung: new FormControl(),
      beLongToID: new FormControl(),
      docType: new FormControl(),
      lstReceiveUsers: new FormControl()

    });
    this.frmGroup = this.formBuilder.group({
      chuDe: ['' , Validators.compose([validateEmpty]) ],
      noiDung: ['', Validators.nullValidator],
      id: ['', Validators.nullValidator],
      beLongToID: ['', Validators.nullValidator],
      docType: ['', Validators.nullValidator],
      lstReceiveUsers: ['', Validators.nullValidator]
    });

    this.uploadUrl= this.documentDraftFileService.urlUpload;
    this.deleteUrl= this.documentDraftFileService.urlDelete;
    this.staffSelectList = [];
    this.selectedList = [];
    /*this.staffsService.findAllByStaffId('-1').subscribe(result => {
      for(let i=0; i< result.length; i++)
      {
        this.staffSelectList= [...this.staffSelectList, {id: result[i].id, fullName: result[i].fullName}];
      }
    });*/

  }
  get f() { return this.frmGroup.controls; }

  createItem ()
  {
    this.frmGroup.value.beLongToID = Sessioncommand.staffId;
    this.frmGroup.value.id =0;
    this.frmGroup.value.lstReceiveUsers = this.uiSelectStaff.selected.join();
    this.frmGroup.value.docType = 'EMAIL';
    this.documentDraftService.add(this.frmGroup.value).subscribe(
      {
        next: (data) => {

          if(this.isEdit === true)
          {

            let thuNew: Thu= new Thu();
            this.thuService.addByDraftId(data.id).subscribe(dt => {
              thuNew= dt;
              this.uploadFileComponent.id = Number(dt.nhomThu);
              this.uploadFileComponent.replyid = 0;
              this.uploadFileComponent.isedit = 1 ;
              this.uploadFileComponent.uploadCommand.upload(this.uploadFileComponent.uploadCommand.getFilesData());
              if(this.dataCheck.length > 0)
              {
              this.thuFileService.guiTiepFile(this.id, dt.nhomThu, this.dataCheck.join(',')).subscribe({
                next: () => {
                },
                error: error => {
                }
                  });
              }
              Sessioncommand.notification = true;
              Sessioncommand.emailStatus = 0;
            });
          }else
          {
            this.uploadFileComponent.id = data.id;
            this.uploadFileComponent.replyid = 0;
            this.uploadFileComponent.isedit =  0 ;
            this.uploadFileComponent.uploadCommand.upload(this.uploadFileComponent.uploadCommand.getFilesData());
            Sessioncommand.emailStatus = 0;
          }
          this.toastr.success(this.isEdit == false ? language.add_success_record : language.send_success_record, language.message);

        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      }
    );

  }
  public showReceive()
  {
    const modalEdit = this.bsModalService.show(GroupSelectComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<GroupSelectComponent>modalEdit.content).showDonVi(
      this.staffSelectList
    );
    (<GroupSelectComponent>modalEdit.content).selectStaffs.subscribe(result => {
      for(let i = 0; i < result.length;i++)
      {
        if(this.staffSelectList.some(e => e["id"] === result[i].id)==false) {
          this.staffSelectList= [...this.staffSelectList, {id: result[i].id, fullName: result[i].fullName + (result[i].chucVuItem !== null ? ' (' + result[i].chucVuItem.tenChucVu + ')' : '')}];
          this.selectedList= [...this.selectedList, result[i].id];
        }
      }
    });
  }

  public onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;

    this.createItem();
    this.onClose.next(true);

  }
  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

